import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appModalHost]'
})
export class ModalHostDirective {
   constructor(public viewContainerRef: ViewContainerRef) { }
}



// WEBPACK FOOTER //
// /app/src/app/directives/modal-host.deirective.ts